import { SESSION_KEY, AZFN_GET_SCHOLAR_FAQs, AZFN_GET_FUTURE_READY_FAQs } from "../common/constants"
import axios from "axios"
import { getCached, setCached } from "@utilities"

export const getFAQs = async (type) => {
    let azureFunction = AZFN_GET_SCHOLAR_FAQs
    let sessionStorageKey = SESSION_KEY.SCHOLAR_FAQS
    switch (type) {
        case "future-ready":
            azureFunction = AZFN_GET_FUTURE_READY_FAQs
            sessionStorageKey = SESSION_KEY.FUTURE_READY_FAQS
            break;
        default:
            break;
    }
    let resourceData = getCached(sessionStorageKey)
    if (!resourceData) {
        const response = await axios.get(`${azureFunction}`)
        resourceData = response.data
        setCached(sessionStorageKey, resourceData)
    }
    return resourceData
}